import { render } from "./UiBadge.vue?vue&type=template&id=6b41dda3&scoped=true"
import script from "./UiBadge.vue?vue&type=script&lang=js"
export * from "./UiBadge.vue?vue&type=script&lang=js"

import "./UiBadge.vue?vue&type=style&index=0&id=6b41dda3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b41dda3"]])

export default __exports__